import React from "react";
import { Clock, MapPin, Navigation, Calendar } from "lucide-react";
import { extractTime } from "../../config/helpers";
// import { extractTime, formatDuration } from '../utils/timeFormat';

const getServiceTypeClass = (serviceType) => {
  switch (serviceType.toLowerCase()) {
    case "ultra beyond":
      return "ultra";
    case "suv":
      return "premium";
    case "black":
      return "standard";
    default:
      return "standard";
  }
};
const formatinHours = (minutes) => {
  return minutes / 60;
};

const BookingCard = ({ booking, onClick }) => {
  const serviceTypeClass = getServiceTypeClass(booking.serviceType);

  return (
    <div className="booking-card-custom" onClick={() => onClick?.(booking._id)}>
      <div className="card-content">
        <div className="card-header">
          <h3 className="customer-name">{booking.customerName}</h3>
          <span className={`service-badge ${serviceTypeClass}`}>
            {booking.serviceType}
          </span>
        </div>

        <div className="location-details">
          <div className="location-item">
            <div className="location-icon pickup">
              <MapPin size={18} />
            </div>
            <div className="location-content">
              <p className="location-label">Pickup Location</p>
              <p className="location-address">
                {booking.pickupLocation?.address || "-"}
              </p>
            </div>
          </div>

          <div className="location-item">
            <div className="location-icon dropoff">
              <Navigation size={18} />
            </div>
            <div className="location-content">
              <p className="location-label">Dropoff Location</p>
              <p className="location-address">
                {booking.dropoffLocation?.address || "-"}
              </p>
            </div>
          </div>
        </div>

        <div className="card-footer">
          <div className="footer-item">
            <Clock size={16} className="footer-icon" />
            <span className="footer-text">{extractTime(booking.time)}</span>
          </div>
          <div className="footer-item">
            <Calendar size={16} className="footer-icon" />
            <span className="footer-text">
              {" "}
              {formatinHours(booking?.duration) >= 1
                ? `${formatinHours(booking?.duration)} Hours`
                : booking?.duration + " Minutes"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCard;
